//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
const { types, uiTypes } = require("./utils/types");
const { validatorTypes } = require("./utils/validatorTypes");

const models = [
  // {
  //   tableName: "leads",
  //   read: true,
  //   create: true,
  //   edit: true,
  //   delete: true,
  //   references: [],
  //   columns: [
  //     {
  //       name: "id",
  //       type: types.UUID,
  //       allowNull: false,
  //       defaultValue: types.UUIDV4,
  //       primaryKey: true,
  //       validation: [validatorTypes.uuid, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: false,
  //         edit: false,
  //       },
  //     },
  //     {
  //       name: "name",
  //       type: types.STRING,
  //       validation: [validatorTypes.string, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "location",
  //       type: types.JSON,
  //       allowNull: true,
  //       validation: [validatorTypes.json, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.MAP,
  //         validation: [],
  //         list: false,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "address",
  //       type: types.STRING,
  //       validation: [validatorTypes.string, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT_AREA, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "city",
  //       type: types.STRING,
  //       isArray: false,
  //       validation: [validatorTypes.string, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "visiting_card_photo",
  //       type: types.STRING,
  //       isArray: false,
  //       validation: [validatorTypes.url, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DOCUMENT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "outside_place_photo",
  //       type: types.STRING,
  //       isArray: false,
  //       validation: [validatorTypes.url, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DOCUMENT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "contact_name",
  //       type: types.STRING,
  //       isArray: false,
  //       validation: [validatorTypes.string, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "contact_number",
  //       type: types.STRING,
  //       validation: [validatorTypes.mobile, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "type_of_client",
  //       type: types.ENUM,
  //       allowNull: false,
  //       defaultValue: null,
  //       enumValues: ["existing", "new", "not interested"],
  //       ui: {
  //         type: uiTypes.DROPDOWN,
  //         validation: [validatorTypes.string, validatorTypes.optional],
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "last_visited",
  //       type: types.DATE,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "last_called",
  //       type: types.DATE,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "price_agreed_upon",
  //       type: types.STRING,
  //       validation: [validatorTypes.string, validatorTypes.optional],
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "next_visit_on",
  //       type: types.DATE,
  //       allowNull: false,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "next_call_on",
  //       type: types.DATE,
  //       allowNull: false,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "status",
  //       type: types.ENUM,
  //       allowNull: false,
  //       defaultValue: null,
  //       enumValues: [
  //         "existing",
  //         "new",
  //         "converted",
  //         "needs time",
  //         "contacting",
  //         "interested",
  //         "lost",
  //         "issue packaging",
  //       ],
  //       ui: {
  //         type: uiTypes.DROPDOWN,
  //         validation: [validatorTypes.string, validatorTypes.optional],
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "type_of_billing",
  //       type: types.ENUM,
  //       allowNull: false,
  //       defaultValue: null,
  //       enumValues: ["half", "full", "none"],
  //       ui: {
  //         type: uiTypes.DROPDOWN,
  //         validation: [validatorTypes.string, validatorTypes.optional],
  //         list: true,
  //         read: true,
  //         create: true,
  //         edit: true,
  //       },
  //     },
  //     {
  //       name: "createdAt",
  //       type: types.DATE,
  //       allowNull: false,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: false,
  //         edit: false,
  //       },
  //     },
  //     {
  //       name: "updatedAt",
  //       type: types.DATE,
  //       allowNull: false,
  //       defaultValue: null,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.DATE, //UI Types
  //         validation: [], //UI Validation
  //         list: true,
  //         read: true,
  //         create: false,
  //         edit: false,
  //       },
  //     },
  //     {
  //       name: "deletedAt",
  //       type: types.DATE,
  //       allowNull: true,
  //       defaultValue: null,
  //       read: false,
  //       ui: {
  //         // added for ui
  //         type: uiTypes.TEXT, //UI Types
  //         validation: [], //UI Validation
  //         list: false,
  //         read: false,
  //         create: false,
  //         edit: false,
  //       },
  //     },
  //   ],
  //   listFunc: null,
  //   readFunc: null,
  //   createFunc: null,
  //   editFunc: null,
  //   deleteFunc: null,
  // },
];

module.exports = models;
